export default function Spinner({ label }: { label?: string }) {
  return (
    <div className="flex items-center gap-3 text-sm text-ink-2">
      <span
        aria-hidden="true"
        className="size-4 animate-spin rounded-full border-2 border-line border-t-brand"
      />
      <span role="status">{label ?? 'Loading…'}</span>
    </div>
  )
}
